import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logoAS from "../assets/logo-as.png";
import { EMPRESA } from "../legal/empresa";
import Nebulosa from "./Nebulosa";
import LanguageSwitcher from "./LanguageSwitcher";

// Layout compartilhado das 3 paginas legais (Privacidade, Termos, Cookies).
// Redesenhado (21/08/2026) pra seguir o mesmo padrao "vidrificado" do resto
// do site (landing/login): fundo Nebulosa, header em vidro com o mesmo
// badge de logo do nav + botao de voltar flutuante, conteudo dentro de um
// card de vidro (blur + saturacao + brilho interno).
// Trilingue (PT/EN/ES) desde 21/08/2026 -- o texto juridico em si (title +
// children) vem de cada pagina (PoliticaPrivacidade/TermosDeUso/PoliticaCookies.js,
// que ja escolhem o idioma certo); aqui so localiza a "moldura" (rotulos,
// botao de voltar, nav do rodape) e expoe o LanguageSwitcher pra trocar
// idioma sem sair da pagina.
const LABELS = {
  pt: { back: "Voltar ao site", updated: "Última atualização:", contact: "Contato:", privacy: "Privacidade", terms: "Termos de Uso", cookies: "Cookies" },
  en: { back: "Back to site", updated: "Last updated:", contact: "Contact:", privacy: "Privacy", terms: "Terms of Use", cookies: "Cookies" },
  es: { back: "Volver al sitio", updated: "Última actualización:", contact: "Contacto:", privacy: "Privacidad", terms: "Términos de Uso", cookies: "Cookies" },
};

export default function LegalLayout({ title, updatedAt, children }) {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || "pt").slice(0, 2);
  const L = LABELS[lang] || LABELS.pt;

  return (
    <div style={{ background: "#0a0c12", minHeight: "100vh", color: "#f1f5f9", position: "relative", overflowX: "hidden" }}>
      <Nebulosa />
      <style>{`
        .legal-content h2 { font-size: 18px; font-weight: 700; margin: 28px 0 10px; color: #f1f5f9; }
        .legal-content p { margin-bottom: 12px; color: #94a3b8; }
        .legal-content ul { margin: 0 0 12px 20px; color: #94a3b8; }
        .legal-content li { margin-bottom: 6px; }
        .legal-content strong { color: #f1f5f9; }
        .legal-back-btn {
          align-items:center;background:rgba(255,255,255,0.06);backdrop-filter:blur(10px) saturate(150%);
          -webkit-backdrop-filter:blur(10px) saturate(150%);border:1px solid rgba(255,255,255,0.14);
          border-radius:999px;box-shadow:0 8px 24px -8px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.12);
          color:#f1f5f9;cursor:pointer;display:flex;font-size:13px;font-weight:600;gap:8px;
          padding:9px 18px 9px 14px;text-decoration:none;transition:background .2s,border-color .2s,transform .2s;
        }
        .legal-back-btn:hover{background:rgba(59,130,246,0.12);border-color:rgba(59,130,246,0.4);transform:translateX(2px);}
        .legal-footer-link { color:#8291a6; font-size:13px; text-decoration:none; transition: color .2s; }
        .legal-footer-link:hover { color:#3b82f6; }
      `}</style>

      <header style={{
        position: "sticky", top: 0, zIndex: 10, backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
        background: "rgba(10,12,18,0.75)", borderBottom: "1px solid rgba(255,255,255,0.08)",
        display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px", gap: 12,
      }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, color: "#f1f5f9", textDecoration: "none" }}>
          {/* Badge "bolha de vidro" -- mesma receita do logo no nav da
              landing (blur + reflexo + sombra interna). */}
          <div style={{
            position: "relative", borderRadius: "50%", height: 34, width: 34,
            display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0,
            background: "rgba(255,255,255,0.06)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)",
            border: "1px solid rgba(255,255,255,0.18)",
            boxShadow: "inset 0 1px 2px rgba(255,255,255,0.35), inset 0 -3px 6px rgba(0,0,0,0.35), 0 2px 8px rgba(0,0,0,0.3)",
          }}>
            <img src={logoAS} alt="logo" style={{ height: "100%", width: "100%", objectFit: "cover" }} />
            <div aria-hidden="true" style={{
              position: "absolute", inset: 0, borderRadius: "50%", pointerEvents: "none",
              background: "linear-gradient(160deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.12) 28%, rgba(255,255,255,0) 55%)",
            }} />
          </div>
          <strong style={{ fontSize: 16 }}>{EMPRESA.nomeFantasia}</strong>
        </Link>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <LanguageSwitcher />
          <Link to="/" className="legal-back-btn">
            <span aria-hidden="true">←</span> {L.back}
          </Link>
        </div>
      </header>

      <main style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 80px", position: "relative", zIndex: 1 }}>
        {/* Card de vidro -- mesma receita usada nos cards de features e no
            modal "Quero Testar" da landing, pra padronizar em toda a
            plataforma. */}
        <div style={{
          background: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.015))",
          backdropFilter: "blur(20px) saturate(150%)", WebkitBackdropFilter: "blur(20px) saturate(150%)",
          border: "1px solid rgba(255,255,255,0.12)", borderRadius: 20,
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.10), 0 30px 70px -30px rgba(0,0,0,0.6)",
          padding: "36px 32px",
        }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 6 }}>{title}</h1>
          <p style={{ color: "#64748b", fontSize: 12.5, marginBottom: 32 }}>
            {L.updated} {updatedAt}
          </p>

          <div className="legal-content" style={{ lineHeight: 1.7, fontSize: 14.5, color: "#f1f5f9" }}>
            {children}
          </div>

          <div style={{
            marginTop: 48, paddingTop: 24, borderTop: "1px solid rgba(255,255,255,0.08)",
            color: "#94a3b8", fontSize: 12.5,
          }}>
            <strong style={{ color: "#f1f5f9" }}>{EMPRESA.razaoSocial}</strong><br />
            CNPJ {EMPRESA.cnpj} — {EMPRESA.cidade}/{EMPRESA.uf}<br />
            {L.contact} <a href={`mailto:${EMPRESA.contatoEmail}`} style={{ color: "#3b82f6" }}>{EMPRESA.contatoEmail}</a>
          </div>

          <div style={{ marginTop: 24, display: "flex", gap: 16 }}>
            <Link to="/privacidade" className="legal-footer-link">{L.privacy}</Link>
            <Link to="/termos" className="legal-footer-link">{L.terms}</Link>
            <Link to="/cookies" className="legal-footer-link">{L.cookies}</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
